import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@modules/material/material.module';
import { SharedModule } from '@modules/shared/shared.module';
import { WebcamModule } from 'ngx-webcam';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { TopNavBarComponent } from './components/topnavbar/topnavbar.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { TelemedChatPanelComponent } from './pages/telemed/components/telemed-chat-panel/telemed-chat-panel.component';
import { TelemedControlsComponent } from './pages/telemed/components/telemed-controls/telemed-controls.component';
import { TelemedOverlayComponent } from './pages/telemed/components/telemed-overlay/telemed-overlay.component';
import { TelemedVideoGridComponent } from './pages/telemed/components/telemed-video-grid/telemed-video-grid.component';
import { TelemedComponent } from './pages/telemed/telemed.component';
import { SessionRoutingModule } from './session-routing.module';
import { SessionComponent } from './session.component';

@NgModule({
  declarations: [
    SessionComponent,
    DashboardComponent,
    NotificationsComponent,
    SearchResultsComponent,
    TopNavBarComponent,
    TelemedComponent,
    TelemedChatPanelComponent,
    TelemedControlsComponent,
    TelemedOverlayComponent,
    TelemedVideoGridComponent,
  ],
  imports: [CommonModule, MaterialModule, SharedModule, WebcamModule, SessionRoutingModule, FormsModule],
})
export class SessionModule {}
